import type { FC } from 'react';
import type { IconProps } from './types';

const Globe: FC<IconProps> = ({ color = 'currentColor', size = 24, strokeWidth = 1.8, ...props }) => {
  const calculatedStrokeWidth = (Number(strokeWidth) * 16) / Number(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      color={color}
      fill="none"
      stroke={color}
      strokeWidth={calculatedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M8.00002 13.6C11.0929 13.6 13.6 11.0929 13.6 8.00002C13.6 4.90714 11.0929 2.40002 8.00002 2.40002C4.90714 2.40002 2.40002 4.90714 2.40002 8.00002C2.40002 11.0929 4.90714 13.6 8.00002 13.6Z" />
      <path d="M5.75996 2.96002H6.31996C5.22798 6.2313 5.22798 9.76874 6.31996 13.04H5.75996" />
      <path d="M9.67999 2.96002C10.772 6.2313 10.772 9.76874 9.67999 13.04" />
      <path d="M2.96002 10.2401V9.68005C6.2313 10.772 9.76874 10.772 13.04 9.68005V10.2401" />
      <path d="M2.96002 6.32002C6.2313 5.22804 9.76874 5.22804 13.04 6.32002" />
    </svg>
  );
};

export default Globe;
